<template>
	<div
		@mouseenter="displayLabel"
		@mouseleave="hideLabel"
		:class="containerClass"
		v-show="this.unreadCount > 0">
		<b-icon-card-text style="width: 20px; height: 20px; margin-top: 1px"></b-icon-card-text>
		<div class="treatmentsessioncomment-indicator__label">
			{{ this.$tc('n-new-comments', this.unreadCount) }}
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			labelActive: false,
		};
	},
	methods: {
		displayLabel() {
			this.labelActive = true;
		},
		hideLabel() {
			this.labelActive = false;
		},
	},
	computed: {
		containerClass() {
			if (this.labelActive) {
				return "treatmentsessioncomment-indicator treatmentsessioncomment-indicator--active";
			}
			return "treatmentsessioncomment-indicator";
		},
		unreadCount() {
			return this.$store.state.treatmentSessionComments.unreadCount;
		},
	},
};
</script>
